import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=1001ff3a&"
import script from "./DocumentEdit.vue?vue&type=script&lang=ts&"
export * from "./DocumentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports